import Swiper, { Thumbs } from 'swiper';

import Swiper, { Thumbs } from "swiper";

const productMainCl = {
    swiperContainer: 'product-main-swiper',
    swiperCarousel: 'swiper-wrapper',
    swiperSlide: 'swiper-slide',
    swiperBtnNext: 'product-main-swiper-button-next',
    swiperBtnPrevious: 'product-main-swiper-button-previous',
    swiperThumbsContainer: 'product-main-swiper-thumbs',
    productMainOptions: 'product-main-options'
}


const enableSwiper = function(thumbs) {
  return new Swiper('.' + productMainCl.swiperContainer, {
    slidesPerView: 'auto',
    spaceBetween: 10,
    
    navigation: {
        nextEl: "." + productMainCl.swiperBtnNext,
        prevEl: "." + productMainCl.swiperBtnPrevious,
      },
      
      thumbs: {
        swiper: thumbs,
      },
    });
  }
  
  const enableSwiperThumbs = function() {
    return new Swiper('.' + productMainCl.swiperThumbsContainer, {
      spaceBetween: 10,
      slidesPerView: 'auto',
      watchSlidesProgress: true,
      
      breakpoints: {
        990: {
          spaceBetween: 24
        }
      }
    });
  }
  
const updateSlide = function(variantId, gallerySwiper, swiperContainer, slideDuration = 1000) {
  const foundSlideIndex = [...swiperContainer.querySelectorAll('.' + productMainCl.swiperSlide)].findIndex(slide => slide.getAttribute('data-variant-id') === variantId);
  if(foundSlideIndex < 0) return;
  
  gallerySwiper.slideTo(foundSlideIndex, slideDuration, false); 
  
  // console.log(`👉 Slide to image: ${foundSlideIndex}`)
  // console.log(`🤠 Variant ID: ${variantId}`)
}

export default function(){
  const swiperContainer = document.querySelector('.' + productMainCl.swiperContainer);
  const swiperThumbsContainer = document.querySelector('.' + productMainCl.swiperThumbsContainer);
  const productOptions = document.getElementById(productMainCl.productMainOptions);
  
  if(!swiperContainer || !swiperThumbsContainer) return;
    Swiper.use( Thumbs );

    const productMainSwiperThumbs = enableSwiperThumbs()
    const productMainSwiper = enableSwiper(productMainSwiperThumbs);

    if (swiperContainer.hasAttribute('data-selected-variant')) {
      updateSlide(swiperContainer.getAttribute('data-selected-variant'), productMainSwiper, swiperContainer, 0); 
    }

    productOptions.addEventListener('click', e => {
      const target = e.target;
      if (target.type === ('radio')) {
        if(target.parentElement.hasAttribute('out-of-stock')) return;

        const variantId = target.getAttribute('data-variant-id');
        if (!variantId) return;

        updateSlide(variantId, productMainSwiper, swiperContainer);
      }
    })
}
